// @generated
// This file is automatically generated by Kanel. Do not modify manually.

import type { ColumnType, Selectable, Insertable, Updateable } from 'kysely';
import { z } from 'zod';

/** Identifier type for public.tag */
export type TagId = string & { __brand: 'public.tag' };

/** Represents the table public.tag */
export default interface TagTable {
  id: ColumnType<TagId, TagId | undefined, TagId>;

  tid: ColumnType<string, string, string>;

  data: ColumnType<string | null, string | null, string | null>;

  supplier_id: ColumnType<string | null, string | null, string | null>;

  _created_at: ColumnType<string, string | undefined, string>;
}

export type Tag = Selectable<TagTable>;

export type NewTag = Insertable<TagTable>;

export type TagUpdate = Updateable<TagTable>;

export const tagId = z.string() as unknown as z.Schema<TagId>;

export const tag = z.object({
  id: tagId,
  tid: z.string(),
  data: z.string().nullable(),
  supplier_id: z.string().nullable(),
  _created_at: z.string(),
}) as unknown as z.Schema<Tag>;

export const tagInitializer = z.object({
  id: tagId.optional(),
  tid: z.string(),
  data: z.string().optional().nullable(),
  supplier_id: z.string().optional().nullable(),
}) as unknown as z.Schema<TagInitializer>;

export const tagMutator = z.object({
  id: tagId.optional(),
  tid: z.string().optional(),
  data: z.string().optional().nullable(),
  supplier_id: z.string().optional().nullable(),
}) as unknown as z.Schema<TagMutator>;
